import { render, staticRenderFns } from "./mobileForm.vue?vue&type=template&id=6b5f50d5&scoped=true&"
import script from "./mobileForm.vue?vue&type=script&lang=js&"
export * from "./mobileForm.vue?vue&type=script&lang=js&"
import style0 from "./mobileForm.vue?vue&type=style&index=0&id=6b5f50d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5f50d5",
  null
  
)

export default component.exports